import { render, staticRenderFns } from "./SwamReport.vue?vue&type=template&id=4f481730&scoped=true"
import script from "./SwamReport.vue?vue&type=script&lang=js"
export * from "./SwamReport.vue?vue&type=script&lang=js"
import style0 from "./SwamReport.vue?vue&type=style&index=0&id=4f481730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481730",
  null
  
)

export default component.exports